import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import React from "react";
import ReactTable from "react-table";
import { Col, Container, Row, Button } from "reactstrap";
import { getProductsClassificationsRequest } from "../../actions/catalogs";
import ProductsBenefits from "../annuitiesConfig/productsBenefits";
import s from "./styles.scss";

interface Props {
  benefits: any;
  updateProductsDiscounts: (productDiscount: any) => any;
  deleteProductsDiscounts: (productDiscount: any) => any;
}

interface State {
  classificationByLevel: any[];
}

class PromotionBenefitsProductsDiscounts extends React.Component<Props, State> {
  state = {
    classificationByLevel: []
  };

  componentDidMount() {
    this.getProductsClassification();
  }

  getProductsClassification = () => {
    getProductsClassificationsRequest().then(({ data }) => {
      this.setState({
        classificationByLevel: [...data]
      });
    });
  };

  discountsColumns = [
    {
      Header: "Tipo producto",
      accessor: "categoriaDescripcion"
    },
    {
      Header: "Producto",
      accessor: "productoNombre"
    },
    {
      Header: "% Descuento",
      accessor: "porcentajeDescuento",
      className: "text-center"
    },
    {
      Header: "$ Descuento",
      accessor: "montoDescuento",
      className: "text-center"
    },
    {
      Header: "No. Códigos Descuento",
      accessor: "numeroCodigosDescuento",
      className: "text-center"
    },
    {
      Header: "Acciones",
      id: "id",
      accessor: pd => {
        return (
          <Container className="w-100 text-center">
            <Button
              color="link"
              onClick={() => {
                console.info(pd);
                this.props.deleteProductsDiscounts(pd);
              }}
              className={`${s.innerButton} ${s.primaryLink}`}
            >
              <FontAwesomeIcon icon={faTimes} />
            </Button>
          </Container>
        );
      }
    }
  ];

  render() {
    return (
      this.props.benefits && (
        <Container className="mt-5">
          <Row className="mt-3">
            <Col>
              <p style={{ color: "red", fontWeight: "bold" }}>
                Descuentos productos
              </p>
            </Col>
          </Row>

          <ProductsBenefits
            classifications={this.state.classificationByLevel}
            addBenefit={productBenefit => {
              console.info(productBenefit);
              this.props.updateProductsDiscounts(productBenefit);
            }}
          />
          <div className="mt-2">
            <ReactTable
              data={this.props.benefits.productosDescuentos}
              columns={this.discountsColumns}
              className="-striped -highlight"
              sortable={false}
              showPagination={false}
              pageSize={
                (this.props.benefits.productosDescuentos || []).length + 1
              }
            />
          </div>
        </Container>
      )
    );
  }
}

export default withStyles(s)(PromotionBenefitsProductsDiscounts);
